import React, { useEffect, useState } from 'react';
import Setting_icon from 'dedicated/components/images/Vector.png';
import Button from 'b2b-ui-components-lib/lib/components/button';
import ToastComponent from 'common/components/toast/toast.component';
import DocsUploadComponent from './DocsUploadComponent';

import { fileSchemaForGSTCertificate, fileSchemaForGSTLOA } from 'home/view/manage-feasibility/constants';

import './index.scss';

export const keyForGSTFiles = {
  GST_CERTIFICATE: 'filesForGSTCerificate',
  GST_LOA: 'filesForGSTLOA'
};

const UploadDocModal = ({
  isOpen = false,
  setIsOpen = () => {},
  title = '',
  onSaveClick = () => {},
  onCancelCb = () => {},
  selectedLocId = '',
  sezTableData = {},
  openViewLineDetailsModal = () => {},
  toast = false,
  setToast = () => {},
  onFileUploadCb = () => {},
  uploadedDocStatus = {},
  isOrderConfirmation = false
}) => {
  const [activeIds, setActiveIds] = useState({});

  useEffect(() => {
    setToast(false, '', '');
    setDefaultFileMeta();
  }, []);

  const setDefaultFileMeta = () => {
    let activeIdsList = {};

    sezTableData.content &&
      sezTableData.content.length > 0 &&
      sezTableData.content.forEach(async (item) => {
        let gstDocumentUrl = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_CERTIFICATE;
        let loaDocument_1 = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_LOA_1;
        let loaDocument_2 = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_LOA_2;
        let loaDocument_3 = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_LOA_3;

        let totalLoaDocs = [];

        if (loaDocument_1) {
          totalLoaDocs = [...totalLoaDocs, { fileUrl: loaDocument_1, key: 1 }];
        }
        if (loaDocument_2) {
          totalLoaDocs = [...totalLoaDocs, { fileUrl: loaDocument_2, key: 2 }];
        }
        if (loaDocument_3) {
          totalLoaDocs = [...totalLoaDocs, { fileUrl: loaDocument_3, key: 3 }];
        }

        if (totalLoaDocs.length > 0 || gstDocumentUrl || item.lineItemId === selectedLocId) {
          activeIdsList[item.lineItemId] = true;
        } else {
          activeIdsList[item.lineItemId] = false;
        }
      });

    setActiveIds(activeIdsList);
  };

  const onFileUpload = (status, type, lineItemId, uploadedFiles) => {
    onFileUploadCb(status, type, lineItemId, uploadedFiles);
  };

  const toggelToastPopup = () => {
    setToast(false, '', '');
  };

  const handleToggle = (id) => {
    setActiveIds((activeIds) => ({
      ...activeIds,
      [id]: !activeIds[id]
    }));
  };

  return (
    <div className={`summary_upload_drawer drawer_modal_controller ${isOpen ? 'active' : ''}`}>
      <div className="drawer h-100p">
        <section id="doc-upload-toast">
          {toast.show && (
            <ToastComponent topPosition={100} closeNetworkCoveragePopup={toggelToastPopup} toastMessage={toast.message} successToast={toast.type} closeToastTime={'8000'} />
          )}
        </section>

        <div className="drawer_header">
          <div className="container">
            <div className="drawer_head">
              <div className="title_info">
                <div className="title_heading">{title}</div>
              </div>
              <span
                className="close_icon"
                onClick={() => {
                  setIsOpen(false);
                  toggelToastPopup();
                  onCancelCb();
                }}
              ></span>
            </div>
          </div>
        </div>
        <div className="drawer_body">
          <div className="scroll_content">
            <div className="container">
              <div className="row">
                <div className="flg-lg-12 flg-md-12">
                  <h5 className="header-name mb-10 fw-600 d-flex-center">
                    <img src={Setting_icon} alt="Alert" style={{ width: 14, height: 14, marginRight: '5px' }} />
                    There {sezTableData.content.length > 1 ? 'are' : 'is'} {sezTableData.content.length} SEZ {sezTableData.content.length > 1 ? 'Sites' : 'Site'}. Upload GST
                    document and Letter of Authorisation against each SEZ site.
                  </h5>
                  {sezTableData.content.length > 0 && <span>All documents are required.</span>}
                </div>
              </div>
              <div className="row">
                <div className="flg-lg-12 flg-md-12">
                  {sezTableData.content.length > 0 &&
                    sezTableData.content.map((item) => (
                      <div key={item.lineItemId} className={` ${'accordion_group'} ${activeIds[item.lineItemId] ? 'active' : ''}`}>
                        <div className="accodion_head_title">
                          <h6>{`LOCATION ID: ${item.lineItemId}`}</h6>
                          <span className="animatedarrow" onClick={() => handleToggle(item.lineItemId)}></span>
                        </div>
                        <div className="accordion_detialed_info">
                          <div
                            role="button"
                            tabIndex="0"
                            className="subtitle-style m-20 cursor-pointer"
                            onClick={() => {
                              openViewLineDetailsModal(item, true);
                              setIsOpen(false);
                            }}
                          >
                            View Details
                          </div>

                          <DocsUploadComponent
                            multiple
                            label="Upload LOA Document"
                            fileSchema={fileSchemaForGSTLOA}
                            type={keyForGSTFiles.GST_LOA}
                            lineItemId={item.lineItemId}
                            onUploadSuccessCb={(status, uploadedFiles) => onFileUpload(status, keyForGSTFiles.GST_LOA, item.lineItemId, uploadedFiles)}
                            setToast={setToast}
                            defaultFiles={
                              uploadedDocStatus &&
                              uploadedDocStatus[item.lineItemId] &&
                              uploadedDocStatus[item.lineItemId][keyForGSTFiles.GST_LOA] &&
                              uploadedDocStatus[item.lineItemId][keyForGSTFiles.GST_LOA]['files']
                            }
                            isOrderConfirmation={isOrderConfirmation}
                          />
                          <DocsUploadComponent
                            label="Upload GST Document"
                            fileSchema={fileSchemaForGSTCertificate}
                            type={keyForGSTFiles.GST_CERTIFICATE}
                            lineItemId={item.lineItemId}
                            onUploadSuccessCb={(status, uploadedFiles) => onFileUpload(status, keyForGSTFiles.GST_CERTIFICATE, item.lineItemId, uploadedFiles)}
                            setToast={setToast}
                            defaultFiles={
                              uploadedDocStatus &&
                              uploadedDocStatus[item.lineItemId] &&
                              uploadedDocStatus[item.lineItemId][keyForGSTFiles.GST_CERTIFICATE] &&
                              uploadedDocStatus[item.lineItemId][keyForGSTFiles.GST_CERTIFICATE]['files']
                            }
                            isOrderConfirmation={isOrderConfirmation}
                          />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="drawer_footer footer-align">
          <div className="container">
            <div className="button_group">
              <Button
                variant="outlinebtn"
                onClick={() => {
                  setIsOpen(false);
                  onCancelCb();
                  toggelToastPopup();
                }}
              >
                Cancel
              </Button>
              <Button onClick={onSaveClick}>Save</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadDocModal;
